// Step 7 commit 9 / AC219: seasonal blocks. Two annual windows where
// no portal orders are accepted (seasonal pricing applies). Mother's
// Day end date is dynamic (2nd Sunday of May).

export type SeasonalBlockReason = "valentines" | "mothers-day";

export type SeasonalBlock = {
  reason: SeasonalBlockReason;
  label: string;
  start: Date;
  endInclusive: Date;
};

// Returns the 2nd Sunday of May for a given year. May always has at
// least 4 Sundays; the 2nd Sunday is at most May 14.
export function mothersDayEnd(year: number): Date {
  const may1 = new Date(Date.UTC(year, 4, 1));
  // getUTCDay: 0 = Sun, 1 = Mon, ..., 6 = Sat.
  const firstSundayOffset = (7 - may1.getUTCDay()) % 7;
  const firstSundayDate = 1 + firstSundayOffset;
  const secondSundayDate = firstSundayDate + 7;
  return new Date(Date.UTC(year, 4, secondSundayDate));
}

export function getSeasonalBlocksFor(year: number): SeasonalBlock[] {
  return [
    {
      reason: "valentines",
      label: "Valentine's Day",
      start: new Date(Date.UTC(year, 1, 1)),
      endInclusive: new Date(Date.UTC(year, 1, 14)),
    },
    {
      reason: "mothers-day",
      label: "Mother's Day",
      start: new Date(Date.UTC(year, 3, 25)),
      endInclusive: mothersDayEnd(year),
    },
  ];
}

function isInRange(d: Date, start: Date, endInclusive: Date): boolean {
  return d.getTime() >= start.getTime() && d.getTime() <= endInclusive.getTime();
}

export function findBlockFor(d: Date): SeasonalBlock | null {
  const year = d.getUTCFullYear();
  for (const yr of [year - 1, year, year + 1]) {
    for (const block of getSeasonalBlocksFor(yr)) {
      if (isInRange(d, block.start, block.endInclusive)) return block;
    }
  }
  return null;
}

export function isBlockedDate(d: Date): boolean {
  return findBlockFor(d) !== null;
}

export function blockTooltipFor(d: Date): string {
  const block = findBlockFor(d);
  if (!block) return "";
  return `${block.label} window — seasonal pricing applies. Contact alexis@magnaflor.com for a quote.`;
}
